const theme = {
	colors: {
		primary: '#393939',
		secondary: '#343436',
		tertiary: '#FF4834',
		black: '#000000',
		white: '#ffffff'
	},
	fonts: {
		primary: 'ITCAvantGardeStd-Demi, monospace',
		secondary: 'HelveticaNeueLTStd-Roman, sans-serif',
		quaternary: 'HelveticaNeueLTStd-BdCn, sans-serif',
		quinary: 'GaramondPremrPro-MedDisp, serif'
	},
};

export default theme;
